module.exports = __webpack_public_path__ + "img/46637-automatic-industries.507c4972.png";